import { init } from '../utils/init';
import initCollectionFilter from '../components/collection-filter';

init((): void => {
  initCollectionFilter();
});
